import CloseIcon from '@mui/icons-material/Close';
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DialogWrapper } from "../../../../../../shared/components/common/dialogWrapper";
import { ButtonWrapper } from "../../../../../../shared/components/formUtilities/useButton";

export const WithdrawErrorDialog = ({ state = false, onClose, error }) => {
  const [isNoIban, setIsNoIban] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (error) {
      setIsNoIban(Object.hasOwn(error, "IbanIsNullOrEmpty"));
    }
  }, [error]);

  return (
    <DialogWrapper
      maxWidth="xs"
      hideCloseBtn
      state={state}
      title={t('withdrawFailed')}
      onClose={() => {
        onClose(false);
      }}
      content={
        <Box className="flex flex-col justify-center">
          <p className="text-center !text-[16px]">
            {isNoIban ? <span>{t('ibanRequired')}</span> : <span>{`${t('minBalanceError')}`}</span>}
          </p>
        </Box>
      }
      actions={
        <Box className="flex items-center space-x-2">
          <ButtonWrapper
            icon={<CloseIcon />}
            variant={'outlined'}
            label={t('close')}
            onClick={() => {
              onClose(false);
            }}></ButtonWrapper>
        </Box>
      }></DialogWrapper>
  );
};